import { useEffect } from 'react';

// Adds `in-view` class to all `.reveal` elements when they enter viewport
export default function useReveal(dep) {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal:not(.in-view)');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [dep]);
}
